module.exports = __webpack_public_path__ + "static/img/lc.25f4a746.svg";